import { useEffect, useRef, useState } from "react";
import { api } from "./api";

// Keadaan Toa Kota untuk semua halaman: toa yang sedang tayang + antrean + perkiraan tunggu.
// Polling tiap 5 dtk; saat toa yang tayang berakhir, segera cek ulang. `sisa` dihitung lokal (koreksi selisih jam server).
export function useToa() {
  const [k, setK] = useState(null);
  const [sisa, setSisa] = useState(0);
  const geser = useRef(0);   // server_at - Date.now() (ms)
  useEffect(() => {
    let alive = true, timer;
    const cek = () => api.toaSekarang().then(d => { if (!alive) return; geser.current = new Date(d.server_at).getTime() - Date.now(); setK(d); }).catch(() => {});
    cek();
    timer = setInterval(cek, 5000);
    return () => { alive = false; clearInterval(timer); };
  }, []);
  useEffect(() => {
    if (!k?.toa) { setSisa(0); return undefined; }
    const akhir = new Date(k.toa.selesai_at).getTime();
    const tick = () => { const s = (akhir - (Date.now() + geser.current)) / 1000; setSisa(Math.max(0, s)); if (s <= 0) api.toaSekarang().then(setK).catch(() => {}); };
    tick();
    const t = setInterval(tick, 500);
    return () => clearInterval(t);
  }, [k]);
  return { toa: k?.toa || null, sisa, antrean: k?.antrean || 0, tunggu: k?.tunggu_detik || 0, tayang: k?.tayang_detik || 30, jarak: k?.jarak_detik || 180, bayar: k?.bayar || null, segarkan: () => api.toaSekarang().then(setK).catch(() => {}) };
}
